import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import type { MainSmsAccountFormInterface } from '@zaoblako/shared/modules/integration/dtos/main-sms/main-sms-account-form.dto';
import type { MainSmsAccountFindInterface } from '@zaoblako/shared/modules/integration/dtos/main-sms/main-sms-account-find.dto';
import { MainSmsIntegrationTypeEnum } from '@zaoblako/shared/modules/integration/enums/main.sms.integration.type.enum';
import { ErrorService } from '@zaoblako/web/core/services/error.service';
import { IntegrationMainsmsService } from '@zaoblako/web/core/services/integration/integration-mainsms.service';
import { NewsletterSmsFormComponent } from '@zaoblako/web/modules/debts/dumbs/newsletter-sms-form/newsletter-sms-form.component';
import { SpinnerComponent } from '@zaoblako/web/shared/dumbs/spinner/spinner.component';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'crm-newsletter-sms-add',
  standalone: true,
  imports: [CommonModule, NewsletterSmsFormComponent, SpinnerComponent],
  templateUrl: './newsletter-sms-add.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewsletterSmsAddComponent implements OnInit {
  public loading = false;
  public sms = <MainSmsAccountFormInterface>{};
  public type: MainSmsIntegrationTypeEnum;

  public constructor(
    private readonly integrationMainsmsService: IntegrationMainsmsService,
    private readonly errorService: ErrorService,
    private readonly ref: DynamicDialogRef,
    private readonly config: DynamicDialogConfig,
    private readonly cdRef: ChangeDetectorRef
  ) {
    if (config.data.type) {
      this.type = config.data.type;
    }
  }

  public ngOnInit() {
    this.sms.type = this.type;
  }

  public create(body: MainSmsAccountFormInterface) {
    this.loading = true;
    this.cdRef.markForCheck();

    this.integrationMainsmsService.create<MainSmsAccountFindInterface>(body).subscribe({
      next: (sms) => {
        this.errorService.addSuccessMessage('Интеграция MainSMS создана');
        this.loading = false;
        this.cdRef.markForCheck();
        this.ref.close(sms);
      },
      error: () => {
        this.loading = false;
        this.cdRef.markForCheck();
      }
    });
  }
}
